import React from "react";
import {
  AspectRatio,
  AspectRatioProps,
  Img,
  useColorModeValue,
} from "@chakra-ui/react";
import { withPrefix } from "gatsby";

export const TUTORIAL_IMAGE_BORDER_RADIUS = "lg";

type TutorialImageProps = {
  src?: string | null;
  alt?: string | null;
} & AspectRatioProps;

export function TutorialImage({ src, alt, ...props }: TutorialImageProps) {
  const bg = useColorModeValue("blue.800", "black.200");

  return (
    <AspectRatio
      ratio={16 / 9}
      bg={bg}
      rounded={TUTORIAL_IMAGE_BORDER_RADIUS}
      overflow="hidden"
      {...props}
    >
      <div>
        <Img
          boxSize="full"
          src={src || withPrefix("/assets/default-course-bg.svg")}
          alt={alt || undefined}
          objectFit="cover"
        />
      </div>
    </AspectRatio>
  );
}
